import { render, staticRenderFns } from "./MessageDetailsOverlay.vue?vue&type=template&id=3c68d286"
import script from "./MessageDetailsOverlay.vue?vue&type=script&lang=js"
export * from "./MessageDetailsOverlay.vue?vue&type=script&lang=js"
import style0 from "./MessageDetailsOverlay.vue?vue&type=style&index=0&id=3c68d286&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports